import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=1c32ff6a&scoped=true&"
import script from "./GamesList.vue?vue&type=script&lang=js&"
export * from "./GamesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32ff6a",
  null
  
)

export default component.exports